import "./App.css";
import React, { useState } from "react";
import {
    BrowserRouter as Router,
    Routes,
    Route,
    Navigate,
} from "react-router-dom";
import ForgotPassword from "./Mescomposants/ForgotPassword/ForgotPassword.js";
import Accueil from "./MesPages/Home/Accueil.js";
import DetailProduct from "./MesPages/Detail/DetailProduct.js";
import Shop from "./MesPages/Shop";
import Cart from "./MesPages/Panier/Cart.js";
import Livraison from "./MesPages/Panier/Livraison.js";
import LoadExternalScripts from "./Mescomposants/LoadExternalScripts";
import Form from "./Dashboard/Form.js";
import Contact from "./MesPages/pageContact/Contact.js";
import PartnerList from "./MesPages/partenaire/PartnerList.js";
import SaveClient from "./MesPages/SaveClient/SaveClient.js";
import TopBar from "./Mescomposants/Header/TopBar";

import Footer from "./Mescomposants/Footer.js";

import DeliverySchedule from "./MesPages/Dashboard/DeliverySchedule.js";
import { ToastContainer } from "react-toastify";
import Commandes from "./MesPages/Commandes/Commandes.js";
import InvoicePDF from "./Mescomposants/exportPDF/InvoicePDF.js";
import Invoices from "./MesPages/Invoices/Invoices.js";
import Performance from "./MesPages/Performance/Performance.js";
import Import from "./MesPages/Import/Import.js";
import Services from "./MesPages/Services/Services.js";
import Dashboard from "./MesPages/Dashboard/Dashboard.js";
import Nouveautes from "./MesPages/Nouveautes/Nouveautes.js"; // Ajout de la nouvelle page nouveauté
import ProtectedRoute from "./Mescomposants/LockAuth/ProtectedRoute.js"; // Ajout protection des routes
import PublicOnlyRoute from "./Mescomposants/LockAuth/PublicOnlyRoute.js"; // Ajouté 20/04/2026
import NetworkStatus from "./Mescomposants/NetworkStatus/NetworkStatus.js";

function App() {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const mode = JSON.parse(localStorage.getItem("appMode"));
    const apiEndpointe = JSON.parse(localStorage.getItem("apiEndpointe"));
    const paths = JSON.parse(localStorage.getItem("appPaths"));

    const urlBaseImage = localStorage.getItem("urlBaseImage");

    const defaultImage = JSON.parse(localStorage.getItem("defaultImage"));

    const imageRuptureStock = localStorage.getItem("imageRuptureStock");

    const params = {
        userData: userData,
        mode: mode,
        apiEndpointe: apiEndpointe,
        paths: paths,
        urlBaseImage: urlBaseImage,
    };
    const [cartCount, setCartCount] = useState(0);
    const [triggerRequest, setTriggerRequest] = useState(false);

    // const handleSuccess = () => {
    //     setTriggerRequest(true); // Déclenche la requête dans B
    // };
    const handleSuccess = (newCount = null) => {
        if (newCount !== null) {
            setCartCount(newCount); // mise à jour immédiate
        }
        setTriggerRequest(true);
    };

    const handleRequestComplete = () => {
        setTriggerRequest(false); // Réinitialise l'état pour permettre un nouveau clic
    };

    // const [quantiteTicketGratuit, setQuantiteTicketGratuit] = useState(false);

    // const handleQuantityUpdate = (totalQuantities) => {
    //   console.log("Quantité totale des tickets:", totalQuantities);
    //   setQuantiteTicketGratuit(totalQuantities);
    // };

    //     console.log({
    //     Form,
    //     Contact,
    //     PartnerList,
    //     SaveClient,
    //     DeliverySchedule,
    //     Performance,
    //     InvoicePDF,
    //     Import,
    //     Services,
    //     Dashboard,
    //     ForgotPassword
    // });

    return (
        <div>
            <NetworkStatus />
            <Router future={{ v7_startTransition: true, v7_relativeSplatPath: true }}> {/*ajout des futures flags de BrownserRouter*/}
                {/* TopBar is now inside Router */}
                {/* <TopBar  quantity={quantiteTicketGratuit}/> */}
                <TopBar
                    param={params}
                    triggerRequest={triggerRequest}
                    onComplete={handleRequestComplete}
                    cartCount={cartCount}
                    setCartCount={setCartCount}
                />
                <Routes>
                    <Route path="*" element={<Navigate to="/" />} />
                    <Route
                        path="/"
                        element={
                            <Accueil
                                param={params}
                                defaultImage={defaultImage}
                                onSuccess={handleSuccess}
                            />
                        }
                    />
                    <Route
                        path="/:slug"
                        element={
                            <DetailProduct
                                param={params}
                                defaultImage={defaultImage}
                                imageRuptureStock={imageRuptureStock}
                                onSuccess={handleSuccess}
                            />
                        }
                    />
                    <Route
                        path="/catalogue/:params?"
                        element={
                            <Shop param={params} defaultImage={defaultImage} onSuccess={handleSuccess} />
                        }
                    />
                    <Route
                        path="/panier"
                        element={
                            <ProtectedRoute>
                                <Cart param={params} onSuccess={handleSuccess} />
                            </ProtectedRoute>

                        }
                    />
                    <Route path="/form" element={<Form />} />

                    <Route
                        path="/contact"
                        element={<Contact param={params} />}
                    />
                    <Route
                        path="/choix-livraison"
                        element={<Livraison param={params} onSuccess={handleSuccess} />}
                    />
                    <Route path="/partenaire" element={<PartnerList />} />
                    <Route path="/saveclient"
                        element={
                            <PublicOnlyRoute>
                                <SaveClient />
                            </PublicOnlyRoute>

                        }
                    />
                    <Route
                        path="/livraison"
                        element={
                            <ProtectedRoute>
                                <DeliverySchedule param={params} />
                            </ProtectedRoute>
                        }
                    />
                    {/* <Route path="/mes-commandes" element={<Commandes />} />
                    <Route path="/factures" element={<Invoices />} /> */}
                    <Route path="/performance" element={<Performance />} />
                    <Route path="/pdf-tst" element={<InvoicePDF />} />
                    <Route
                        path="/importation"
                        element={
                            <ProtectedRoute>
                                <Import param={params} onSuccess={handleSuccess} />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="/services"
                        element={<Services param={params} />}
                    />
                    <Route
                        path="/tableau-de-bord"
                        element={
                            <ProtectedRoute>
                                <Dashboard param={params} />
                            </ProtectedRoute>
                        }
                    />
                    <Route path="forgot-password" element={<ForgotPassword />} />
                    {/* Redirection vers la page d'accueil */}
                    <Route
                        path="/nouveautes"
                        element={
                            <Nouveautes
                                param={params}
                                defaultImage={defaultImage}
                            />
                        }
                    />
                    {/* ajout de la route nouveautes */}
                </Routes>
                <Footer param={params} />
            </Router>
            <LoadExternalScripts />
            <ToastContainer />
        </div>
    );
}

export default App;
